import React, { Component } from 'react'
import { observer } from 'mobx-react'

import {
    Button,
    Col,
    Grid,
    Label,
    Row
} from 'react-bootstrap'

import InvoiceDetails from './invoicedetails'

@observer(['agreements', 'invoices', 'quickbooks', 'globals'])
export default class BhphView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            signature: ''
        }
    }

    //State Change Handlers
    signatureChanged(e) {
        this.setState({
            signature: e.target.value
        })
    }

    render() {
        var signaturePanel = (
            <div className="row small-top-margin hidden-print">
                <div className="col-xs-12">
                    <div class="form-group">
                        <label class="small-top-margin control-label col-md-3 col-sm-3 col-xs-12">
                            Electronic Signature: By typing your full name below, you agree to be bound by the terms and conditions detailed above.
                        </label><br />
                        <input type="text" className="form-control show-border" onChange={this.signatureChanged.bind(this)} placeholder="" />
                    </div>
                </div>
            </div>
        )

        let paymentNotification = ''
        let buttonDisplay = <Button className="btn btn-success pull-right fa fa-credit-card" onClick={() => { this.props.redirectProcessPaymentPage(this.props.invoices.invoiceViewDetails.invoiceId, this.state.signature) }}><i></i> Submit Payment</Button>

        if (this.props.invoices.invoiceViewDetails.paymentId !== null) {
            paymentNotification = <h2><strong>YOU HAVE ALREADY PROCESSED A PAYMENT FOR THIS INVOICE!</strong></h2>
            buttonDisplay = <Button disabled className="btn btn-success pull-right fa fa-credit-card" ><i></i> Payment Already Processed</Button>
            signaturePanel = ''
        }

        return (
            <div className="checkout-container">
                <Grid>
                    <Row>
                        <Col xs={0} md={2}></Col>
                        <Col xs={12} md={8}>
                            <Row className="hidden-print center">
                                <Col>
                                    {paymentNotification}
                                </Col>
                            </Row>
                            <Row>
                                <Col className="center">
                                    <p><img src="/images/logo-white.png" /></p>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="center">
                                    <p><img src="/images/bhph_header.jpg" /></p>
                                </Col>
                            </Row>
                            <Row className="large-top-margin"></Row>
                            <Row className="large-top-margin hidden-print"></Row>
                            <Row className="pagebreak-print">
                                <Col className="center">
                                    <h1>GPS Leaders Proposal</h1>
                                    <h3>By: {this.props.invoices.invoiceViewDetails.userFullName}</h3>
                                    <h3>{this.props.invoices.invoiceViewDetails.userEmail}</h3>
                                </Col>
                            </Row>
                            {/*
                            <Row className="large-top-margin hidden-print"><hr /></Row>
                            <Row>
                                <Col>
                                    <h1 className="center">Introducing GPS Leaders, LLC</h1>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <blockquote>A leader in payment assurance and GPS Tracking devices. Over 25 years in the business. We put our customers 1st and work hard to make sure our clients are not just getting high quality products at a great price but also excellent customer service.</blockquote>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="center">
                                    <p><a href="https://gpsleaders.com/wp-content/uploads/2017/09/2017_lender_report.pdf" target="_blank"><img src="/images/cta_report_btn.jpg" /></a></p>
                                </Col>
                            </Row>
                            <Row className="center pagebreak-print">
                                <Col>
                                    <h1 className="center">3 Year Manufactures Warranty</h1>
                                    <blockquote>
                                        <p>We are committed to providing top-quality products and solutions to our customers. If our GPS device stops performing as advertised anytime within a 3 year period we will replace that device free of charge, no questions asked.</p>
                                    </blockquote>
                                </Col>
                            </Row>
                            <Row className="large-top-margin hidden-print"><hr /></Row>
                            <Row>
                                <Col>
                                    <h1 className="center">The PERFECT Repossession Recovery System</h1>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <h2 className="center">Find Impounded Vehicles within 4 Hours</h2>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <blockquote>
                                        <p className="center">What are the TOP 10 THINGS Used Car Dealers, Auto Lenders and Credit Unions ALL have in Common?</p>
                                        <p>They all WANT...</p>
                                        <p>
                                            <ol>
                                                <li>Faster Vehicle Recovery</li>
                                                <li>Reduce Risk of Consumer Default</li>
                                                <li>Improve Credit Rating for their Buyers</li>
                                                <li>More Consistent Payments by the Consumer</li>
                                                <li>Reduce the Overall Risk of Financing Subprime Consumers</li>
                                                <li>More Financing for a Higher Actual Cash Value (ACV) Vehicle</li>
                                                <li>The Ability for Collectors to Handle a Larger # of Accounts per Agent</li>
                                                <li>Reduced Collection Cost, Delinquencies &amp; Alter Customer Behavior</li>
                                                <li>A Win, Win for Both the Lender and the Consumer</li>
                                                <li>Reduce Overall Cost of Collections</li>
                                            </ol>
                                        </p>
                                    </blockquote>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="center pagebreak-print">
                                    <p><img src="/images/seals.jpg" /></p>
                                </Col>
                            </Row>
                            <Row className="large-top-margin hidden-print"><hr /></Row>
                            <Row className="center">
                                <Col md={2}>
                                    <p><img src="/images/dollar-sign.png" /></p>
                                </Col>
                                <Col>
                                    <h1 className="center">Get More for Your Money</h1>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <blockquote>
                                        <p>Our system provides 2 minute updates while driving vs 25 hour updates from our competitors. It pretty obvious to us that more data is better when trying to retrieve your valuable assets. We also offer automatic Impound Yard Notifications within 4 hours at no extra charge. This feature alone can save you thousands annually.</p>
                                    </blockquote>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="quoteview_testimonial_dark">
                                    <blockquote>
                                        <h2>“One of my vehicles showed up at an impound yard in a different state and I was notified within a few hours, it really works”</h2>
                                        <h4>- Jimmy’s Auto Sales</h4>
                                    </blockquote>
                                </Col>
                            </Row>
                            <Row className="checkout_col_container center">
                                <Col className="quoteview_testimonial_blue">
                                    <blockquote>
                                        <p>Jimmy’s Auto Sales, saved approximately $600 because he was notified that same day. He stated had he not been notified in such a timely fashion, it may not of been worth it to retrieve his vehicle which could of cost him thousands.</p>
                                    </blockquote>
                                </Col>
                            </Row>
                            <Row className="pagebreak-print">
                                <Col className="center">
                                    <p><img src="/images/gps_collage.jpg" /></p>
                                </Col>
                            </Row>
                            <Row className="center hidden-print">
                                <Col>
                                    <h3><Label bsStyle="primary">Call (855) 432-6423 Today!</Label></h3>
                                </Col>
                            </Row>
                            <Row className="large-top-margin hidden-print"><hr /></Row>
                            */}
                            <Row className="pagebreak-print">
                                <Col>
                                    <InvoiceDetails token={this.props.token} emailStatus={true} setLoadableState={ this.props.setLoadableState.bind(this) }/>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className="row hidden-print">
                                        <div className="col-xs-12">
                                            <p className="lead">Terms and Conditions</p>
                                            <div className="agreement-container small-top-margin">
                                                {this.props.invoices.invoiceViewDetails.agreementDetails}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row visible-print">
                                        <div className="col-xs-12">
                                            <p className="lead">Terms and Conditions</p>
                                            <div className="agreement-container-print small-top-margin">
                                                {this.props.invoices.invoiceViewDetails.agreementDetails}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row small-top-margin visible-print">
                                        <div className="col-xs-12">
                                            <div class="form-group">
                                                <label class="small-top-margin control-label col-md-3 col-sm-3 col-xs-12">
                                                    By signing your full name below, you agree to be bound by the terms and conditions detailed above.
                                                </label>
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td>Signature: </td>
                                                            <td>________________________________</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Name: </td>
                                                            <td>________________________________</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Date: </td>
                                                            <td>________________________________</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    { signaturePanel }
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className="row small-top-margin hidden-print">
                                        <div className="col-xs-12">
                                            {buttonDisplay}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={0} md={2} />
                    </Row>
                </Grid>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/invoices/bhphview.js